import { Component, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exportData from 'highcharts/modules/export-data';
import HC_OfflineExporting from 'highcharts/modules/offline-exporting';
HC_exporting(Highcharts);
HC_exportData(Highcharts);
HighchartsMore(Highcharts);
HC_OfflineExporting(Highcharts);

@Component({
  selector: 'monorepo-ui-charts',
  templateUrl: './ui-charts.component.html',
  styleUrls: ['./ui-charts.component.scss'],
})
export class UiChartsComponent {
  constructor() {}

  @Input() highChartsConfig!: Highcharts.Options;
  /**
   * For getting full screen height charts,
   * don't set height property in Highcharts.Options highChartsConfig
   * and pass chartFullHeight as true
   * */
  @Input() chartFullHeight?: boolean = false;

  /**
   * Renders only the chart, without the ion-grid wrapper.
   * The grid brings the Ionic font cascade with it, which shifts the Highcharts styles.
   * `chartFullHeight` has nothing to size without the grid, the host has to size the chart instead.
   */
  @Input() bare = false;

  Highcharts: typeof Highcharts = Highcharts;
}
